import axiosApiClient from "../axios";

const PATH = "/api/notifications";

// SYSTEM_ADMIN / ADMIN — send a notification to a specific user.
// The backend persists it and pushes it over WebSocket to the
// recipient's active sessions (web + mobile).
export const sendNotification = async ({recipientUserId, title, body, type}) => {
    try {
        const res = await axiosApiClient.post(PATH, {recipientUserId, title, body, type});
        return res.data;
    } catch (err) {
        throw new Error(err.response?.data?.message || "Failed to send notification");
    }
};

export const getMyNotifications = async ({page = 0, size = 20, unreadOnly = false} = {}) => {
    try {
        const res = await axiosApiClient.get(`${PATH}/mine`, {
            params: {page, size, unreadOnly},
        });
        return res.data;
    } catch (err) {
        throw new Error(err.response?.data?.message || "Failed to load notifications");
    }
};

export const getMyUnreadCount = async () => {
    try {
        const res = await axiosApiClient.get(`${PATH}/mine/unread-count`);
        return res.data?.count ?? 0;
    } catch {
        // Soft fail — unread count is non-critical; return 0 on error.
        return 0;
    }
};

export const markRead = async (id) => {
    try {
        const res = await axiosApiClient.put(`${PATH}/${id}/read`);
        return res.data;
    } catch (err) {
        throw new Error(err.response?.data?.message || "Failed to mark notification read");
    }
};

export const markAllRead = async () => {
    try {
        const res = await axiosApiClient.put(`${PATH}/mine/read-all`);
        return res.data?.updated ?? 0;
    } catch (err) {
        throw new Error(err.response?.data?.message || "Failed to mark all read");
    }
};
